/* eslint-disable sort-imports */
import {
  disableBodyScroll,
  enableBodyScroll,
} from 'body-scroll-lock/lib/bodyScrollLock.min.js';
import getAdminBarHeight from '../utils/getAdminBarHeight';

export default class Header {
  constructor() {
    this.selector = '.header--enabled-sticky';

    this.selectors = {
      headerMain: '.header--main',
      adminBar: 'wpadminbar',
      root: 'html',
      btnNav: '.header--main .btn-nav',
      headerMenu: '.header--main .header__menu',
      announcementBarTop: '.c-announcement-bar--top',
      modal: '.c-modal',
      contentMenu: '.b-content-menu',
      headerDevZoneBtnNav: '.header--dev-zone',
    };

    this.classes = {
      active: 'active',
      mobileVisible: 'mobile-nav-visible',
      mobileVisibleDevZone: 'mobile-nav-visible-dev-zone',
      mobileMenuActive: 'menu-item--active',
      menuItemDropdown: 'sub-menu',
      sticky: 'header--sticky',
      visible: 'header--visible',
      headerMenu: 'header__menu',
      announcementBarHidden: 'c-announcement-bar--hidden',
    };

    this.nodes = {};
  }

  bootstrap() {
    this.getNodes();
    this.calculateMenuHeight();
    this.setupBurgerButton();
    this.setupBurgerButtonDevZone();
    this.initHeaderTopPositionWithBar();

    window.addEventListener('load', this.loadListeners.bind(this));
    window.addEventListener('resize', this.resizeListeners.bind(this));
    window.addEventListener('scroll', this.scrollListeners.bind(this));
  }

  loadListeners() {
    this.headerOnScroll();
    this.calculateMenuHeight();
    this.handleHeaderTopPositionWithBar();
  }

  resizeListeners() {
    this.calculateMenuHeight();
    this.handleHeaderTopPositionWithBar();
  }

  scrollListeners() {
    this.headerOnScroll();
    this.handleHeaderTopPositionWithBar();
  }

  getNodes() {
    this.nodes = {
      headerMain: document.getElementById(this.selectors.headerMain),
      headerDevZoneBtnNav: document.querySelector(
        this.selectors.headerDevZoneBtnNav,
      ),
      adminBar: document.getElementById(this.selectors.adminBar),
      root: document.querySelector(this.selectors.root),
      header: document.querySelector(this.selector),
      headerMenu: document.querySelector(this.selectors.headerMenu),
      btnNav: document.querySelector(this.selectors.btnNav),
      contentMenu: document.querySelectorAll(this.selectors.contentMenu),
      announcementBarTop: document.querySelector(
        this.selectors.announcementBarTop,
      ),
      modals: document.querySelectorAll(this.selectors.modal),
    };
  }

  initHeaderTopPositionWithBar() {
    const { announcementBarTop } = this.nodes;

    if (!announcementBarTop) {
      return;
    }

    $(window).on('announcement-bar-hiding', () => {
      this.handleHeaderTopPositionWithBar();
    });
  }

  handleHeaderTopPositionWithBar() {
    const { announcementBarTop, header } = this.nodes;
    const { announcementBarHidden } = this.classes;
    let headerOffsetFromBar = 0;

    if (!announcementBarTop) {
      return;
    }

    if (announcementBarTop.classList.contains(announcementBarHidden)) {
      headerOffsetFromBar = getAdminBarHeight({ node: this.nodes.adminBar });
    } else {
      headerOffsetFromBar =
        announcementBarTop.offsetHeight +
        parseFloat(announcementBarTop.style.top, 10);
    }

    header.style.top = `${headerOffsetFromBar}px`;
  }

  calculateMenuHeight() {
    this.totalHeight =
      window.innerHeight - getAdminBarHeight({ node: this.nodes.adminBar });

    this.makeMenuScrollable();
  }

  setupBurgerButton() {
    const { btnNav } = this.nodes;

    if (btnNav) {
      btnNav.addEventListener('click', this.toggleNav.bind(this));
    }
  }

  setupBurgerButtonDevZone() {
    const { headerDevZoneBtnNav } = this.nodes;

    if (headerDevZoneBtnNav) {
      headerDevZoneBtnNav.addEventListener(
        'click',
        this.toggleNavDevZone.bind(this),
      );
    }
  }

  makeMenuScrollable() {
    const { headerMenu } = this.nodes;

    if (!headerMenu) {
      return;
    }

    headerMenu.style.setProperty('--viewport-height', `${this.totalHeight}px`);
  }

  toggleNav() {
    const { root, btnNav, headerMenu, modals } = this.nodes;
    const { mobileVisible, active } = this.classes;

    root.classList.toggle(mobileVisible);
    btnNav.classList.toggle(active);

    if (root.classList.contains(mobileVisible)) {
      disableBodyScroll(headerMenu);

      modals.forEach(modal => {
        disableBodyScroll(modal);
      });
    } else {
      enableBodyScroll(headerMenu);

      modals.forEach(modal => {
        enableBodyScroll(modal);
      });
    }
  }

  toggleNavDevZone() {
    const { root, headerMenu, modals } = this.nodes;
    const { mobileVisibleDevZone } = this.classes;

    root.classList.toggle(mobileVisibleDevZone);

    if (root.classList.contains(mobileVisibleDevZone)) {
      disableBodyScroll(headerMenu);

      modals.forEach(modal => {
        disableBodyScroll(modal);
      });
    } else {
      enableBodyScroll(headerMenu);

      modals.forEach(modal => {
        enableBodyScroll(modal);
      });
    }
  }

  headerOnScroll() {
    const scrollTop = window.pageYOffset;
    const target = getAdminBarHeight({ node: this.nodes.adminBar }) || 5;

    if (scrollTop >= target) {
      this.toggleHeaderClasses('down');
    } else {
      this.toggleHeaderClasses('up');
    }

    this.toggleHeaderVisibility();
  }

  toggleHeaderClasses(dir) {
    const { header } = this.nodes;
    const { sticky } = this.classes;

    if (!header) {
      return;
    }

    if (dir === 'down') {
      header.classList.add(sticky);
      document.body.classList.add(`--${sticky}`);
    } else {
      header.classList.remove(sticky);
      document.body.classList.remove(`--${sticky}`);
    }
  }

  toggleHeaderVisibility() {
    const { header } = this.nodes;
    const { sticky, visible } = this.classes;

    if (!header) {
      return;
    }

    if (this.scrollTop > window.scrollY && header.classList.contains(sticky)) {
      header.classList.add(visible);
      document.body.classList.add(`--${visible}`);
    } else {
      header.classList.remove(visible);
      document.body.classList.remove(`--${visible}`);
    }

    this.scrollTop = window.scrollY;
  }
}
